module.exports = __webpack_public_path__ + "static/media/produkt.159b0203.png";